import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { BancoService } from '../../../../../services/banco/banco.service';
import { PendenciaCaminhaoProprioQuitado } from '../../../model/veiculo';

@Component({
  selector: 'app-dados-caminhao-proprio-quitado',
  templateUrl:
    './dados-caminhao-proprio-quitado.component.html',
  styleUrls: [
    './dados-caminhao-proprio-quitado.component.scss',
  ],
})
export class DadosCaminhaoProprioQuitadoComponent
  implements OnInit, OnDestroy {
  @Input() value: PendenciaCaminhaoProprioQuitado;
  @Output() changeForm: EventEmitter<any> = new EventEmitter();
  @Output() changeFormValid: EventEmitter<any> = new EventEmitter();

  @ViewChild('naoVeiculoQuitado', { static: true })
  naoVeiculoQuitado: any;
  @ViewChild('simVeiculoQuitado', { static: true })
  simVeiculoQuitado: any;

  form: FormGroup;
  bancos: any[];

  private subsVeiculoQuitado: Subscription;
  private subsForm: Subscription;
  public isAlteracao: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private bancoService: BancoService
  ) {}

  ngOnInit() {
    this.buildForm();
    this.setForm();
    this.watchForm();
    this.getBancos();
  }

  ngOnDestroy() {
    if (this.subsVeiculoQuitado) {
      this.subsVeiculoQuitado.unsubscribe();
    }
    if (this.subsForm) {
      this.subsForm.unsubscribe();
    }
  }

  private setForm(): void {
    if (this.value) {
      if (
        this.value.veiculoQuitado ||
        (!this.value.veiculoQuitado &&
          this.value.veiculoQuitado !== undefined &&
          this.value.veiculoQuitado !== null)
      ) {
        this.simVeiculoQuitado.value = this.value.veiculoQuitado;
        this.naoVeiculoQuitado.value = !this.value.veiculoQuitado;
      } else if (this.value.veiculoQuitado !== undefined && this.value.veiculoQuitado !== null) {
        this.simVeiculoQuitado.value = this.value.veiculoQuitado;
        this.naoVeiculoQuitado.value = !this.value.veiculoQuitado;
      }
      if (!this.value.veiculoQuitado && this.value && this.value.banco && (this.value.banco.id || this.value.banco.codigo)) {
        this.isAlteracao = true;
        this.getBancos();
      }
    }
  }

  private watchForm(): void {
    this.subsVeiculoQuitado = this.form
      .get('veiculoQuitado')
      .valueChanges.subscribe(() => {
        this.form.get('totalParcela').setValue(null);
        this.form.get('valorParcela').setValue(null);
        this.form.get('parcelasQuitada').setValue(null);
        this.form.get('banco').setValue(null);
      });
    if (this.formValid) {
      this.subsForm = this.form.valueChanges.subscribe(() => {
        this.changeForm.emit(this.form.value);
        this.changeFormValid.emit(this.formValid);
      });
      this.changeForm.emit(this.form.value);
      this.changeFormValid.emit(this.formValid);
    } else {
      this.subsForm = this.form.valueChanges.subscribe(() => {
        this.changeForm.emit(this.form.value);
        this.changeFormValid.emit(this.formValid);
      });
    }
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      veiculoQuitado: this.value ? this.value.veiculoQuitado : null,
      totalParcela: this.value ? this.value.totalParcela : null,
      valorParcela: this.value ? this.value.valorParcela : null,
      parcelasQuitada: this.value ? this.value.parcelasQuitada : null,
      banco: this.value ? this.value.banco : null,
    });
  }

  public setVeiculoQuitado(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'naoVeiculoQuitado') {
      this.simVeiculoQuitado.value = !component.checked;
      this.form.get('veiculoQuitado').setValue(!component.checked);
      return;
    }

    this.naoVeiculoQuitado.value = !component.checked;
    this.form.get('veiculoQuitado').setValue(component.checked);
  }

  private getBancos(): void {
    this.bancoService
      .getBancos()
      .pipe(take(1))
      .subscribe((res: any[]) => {
        this.bancos = res;
        if (this.isAlteracao && this.value && this.value.banco) {
          const bank = this.bancos.find(
            (f) => Number(f.codigo) === Number(this.value.banco.id || this.value.banco.codigo)
          );
          this.form.get('banco').setValue(bank);
        }
        this.form.updateValueAndValidity();
      });
  }

  public get veiculoQuitado(): boolean {
    return this.form.get('veiculoQuitado').value;
  }

  public get showDadosPreencher(): boolean {
    return (
      !this.veiculoQuitado &&
      this.veiculoQuitado !== null &&
      this.veiculoQuitado !== undefined
    );
  }

  public get formValid(): boolean {
    const {
      veiculoQuitado,
      totalParcela,
      valorParcela,
      parcelasQuitada,
      banco,
    } = this.form.getRawValue();

    if (!veiculoQuitado) {
      return totalParcela && valorParcela && parcelasQuitada && banco && this.isParcelasValid;
    }

    return veiculoQuitado;
  }

  public get isParcelasValid() {
    const {
      totalParcela,
      parcelasQuitada,
    } = this.form.getRawValue();

    if (totalParcela && parcelasQuitada) {
      return Number(totalParcela) > Number(parcelasQuitada);
    }

    return true;
  }
}
